import React from 'react';
import MantineBadge from "../../../components/mantine/badge";

const StatusComponents = (props:any) =>{
    const { item }=props;
    return(
    <MantineBadge fullWidth variant="light" color={item?.isActive ? 'teal' : 'red'}>
        {item?.isActive ? 'Active' : 'Disabled'}
    </MantineBadge>
);
};

export default StatusComponents;